import InformationBadge from '@c/InformationBadge';
import { getBikeFitment } from 'app/product/utils/getBikeFitment';
import { useAuth } from 'context/AuthContext';
import { ProductDocument } from 'models/product';

type FitmentInformationBadgesProps = {
  product: ProductDocument;
};

export default function FitmentInformationBadges({
  product,
}: FitmentInformationBadgesProps) {
  const { userDoc } = useAuth();
  const bikes = userDoc?.bikes ?? [];

  if (
    !product.category.toLowerCase().includes('parts') ||
    !product.fitting_bikes
  ) {
    return null;
  }

  const fitment = getBikeFitment(
    product?.fitting_bikes?.bikes ?? [],
    bikes,
    !!product.integration_info
  );

  if (product.fitting_bikes.universal) {
    return (
      <InformationBadge
        text={`This part has been listed as universal fitment. Please verify compatibility with the seller.`}
        type="info"
      />
    );
  } else if (fitment.multiple && fitment.status === 'fits') {
    return (
      <InformationBadge
        text={`Fits multiple bikes in your garage`}
        type="success"
      />
    );
  } else if (fitment.multiple && fitment.status === 'may-fit') {
    return (
      <InformationBadge
        text={`May fit multiple bikes in your garage`}
        type="warning"
      />
    );
  } else if (fitment.status === 'may-fit' && fitment.bike) {
    return (
      <InformationBadge
        text={`May fit your ${fitment.bike.make} ${fitment.bike.year} ${fitment.bike.model}`}
        type="warning"
      />
    );
  } else if (fitment.status === 'fits' && fitment.bike) {
    return (
      <InformationBadge
        text={`Fits your ${fitment.bike.make} ${fitment.bike.year} ${fitment.bike.model}`}
        type="success"
      />
    );
  } else {
    return (
      <InformationBadge
        text={`Does not fit any of your ${bikes.length} bikes`}
        type="error"
      />
    );
  }
}
